export const GET_ITEM_COUNT = 7;
export const VISIBILITY_TIMEOUT: number = 60 * 1000;
export const MAX_ATTEMPTS = 10;

/**
 * Defensive fallback for the maximum number of analytics events stored per product in the
 * resilience layer (IndexedDB or in-memory). This value is used by ResilienceDb when no
 * maxEventLimit is explicitly provided.
 *
 * In practice, PullBatchableQueue always passes a resolved maxEventLimit from
 * DEFAULT_POLLING_OPTIONS.maxQueueSize, so this constant serves as a safety net for any
 * future direct usage of ResilienceDb.
 */
export const EVENT_COUNT_LIMIT: number = 8000;
